import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import MoodBadOutlinedIcon from '@mui/icons-material/MoodBadOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const labelsChild = {
    "1": "Ikke gøy",
    "2": "Skummelt",
    "3": "Litt gøy",
    "4": "Veldig gøy",
    "5": "Vet ikke"
};

const labelsParent = {
    "1": "Veldig utilfreds",
    "2": "Litt utilfreds",
    "3": "Vet ikke",
    "4": "Litt tilfreds",
    "5": "Veldig tilfreds"
};

const answerStyles = {
    1: { label: 'Ikke gøy', color: '#D75B6C', background: '#FDECEC', icon: MoodBadOutlinedIcon },
    2: { label: 'Skummelt', color: '#C96A2D', background: '#FCE7D9', icon: SentimentDissatisfiedOutlinedIcon },
    3: { label: 'Litt gøy', color: '#4B6F95', background: '#EDF3FA', icon: SentimentSatisfiedOutlinedIcon },
    4: { label: 'Veldig gøy', color: '#3F7F4C', background: '#EAF7E3', icon: SentimentVerySatisfiedOutlinedIcon },
    5: { label: 'Vet ikke', color: '#B7791F', background: '#FFF4D6', icon: HelpOutlineIcon },
};

const answerStylesParent = {
    1: { color: '#B64050', background: '#FCE8EB', icon: MoodBadOutlinedIcon },
    2: { color: '#C96A2D', background: '#FCE7D9', icon: SentimentDissatisfiedOutlinedIcon },
    3: { color: '#B7791F', background: '#FFF4D6', icon: HelpOutlineIcon },
    4: { color: '#4B6F95', background: '#EDF3FA', icon: SentimentSatisfiedOutlinedIcon },
    5: { color: '#3F7F4C', background: '#DDF2D8', icon: SentimentVerySatisfiedOutlinedIcon },
};

export default function EvaluationCard({ data, type }) {

    const questions = type === "parent"
        ? [
            "Hvor tilfreds er dere med informasjonen dere fikk i forkant av oppholdet?",
            "Hvor tilfreds er dere med informasjonen dere har fått i løpet av oppholdet?",
            "Var dere delaktige i utforming av målsetting for oppholdet?",
            "Var aktivitetstilbudet godt tilrettelagt?",
            "Har det vært fokus på oppfølging i etterkant av oppholdet?",
            "Hvor tilfreds er dere med det generelle utbyttet av oppholdet?"
        ]
        : [
            "Hvordan har ditt opphold på helsesportsenteret vært?",
            "Har du lært noe nytt mens du har vært på helsesportsenteret?",
            "Hvordan har det vært å være i en gruppe sammen med andre?"
        ];

    const labels = type === "parent" ? labelsParent : labelsChild;

    const aggregate = (index) => {
        const counts = {};

        Object.keys(labels).forEach((key) => {
            counts[key] = 0;
        });

        data.forEach((item) => {
            const evalArray =
                type === "parent"
                    ? item.parentEvaluation || []
                    : item.childEvaluation || [];

            const answer = evalArray[index]?.Answer;
            if (answer && counts.hasOwnProperty(answer)) {
                counts[answer]++;
            }
        });

        return counts;
    };

    return (
        <Box sx={{ display: "grid", gap: 3 }}>
            {questions.map((question, index) => {
                const counts = aggregate(index);

                return (
                    <Card key={index} sx={{ borderRadius: '12px', border: '1px solid #E1E8F0', boxShadow: '0 2px 8px rgba(28, 55, 90, 0.04)' }}>
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                            <Typography sx={{ mb: 2, color: '#17233D', fontSize: 18, fontWeight: 700 }}>
                                {question}
                            </Typography>

                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: 1.5 }}>
                                {(type === 'parent' ? ['1', '2', '4', '5', '3'] : Object.keys(counts)).map((key) => {
                                    const count = counts[key];
                                    const answer = (type === 'parent' ? answerStylesParent : answerStyles)[key];
                                    const Icon = answer.icon;
                                    return (
                                        <Box
                                            key={key}
                                            sx={{ minHeight: 52, px: 1.5, display: 'flex', alignItems: 'center', gap: 1, bgcolor: answer.background, color: answer.color, borderRadius: '9px' }}
                                        >
                                            <Icon sx={{ fontSize: 25 }} />
                                            <Typography sx={{ flex: 1, minWidth: 0, color: 'inherit', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap' }}>
                                                {type === 'parent' ? labels[key] : answer.label}
                                            </Typography>
                                            <Box sx={{ width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', bgcolor: 'rgba(255, 255, 255, 0.7)', fontSize: 13, fontWeight: 700 }}>
                                                {count}
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </CardContent>
                    </Card>
                );
            })}
        </Box>
    );
}